import { httpCreate, getUrlPath } from './http';

const http = httpCreate('/shop/api/reseller');

export const shopReseller = {
	list(activityId) {
		return http.post('/listnp', { activityId });
	},
};
